import Button from '@components/V4/Button';
import Input from '@components/V4/Inputs/Input';
import apiClient from '@contexts/AuthContext/apiClient';
import { reportApis } from '@shared/apis';
import useToast from 'apps/agora/src/hooks/useToast';
import JSZip from 'jszip';
import moment from 'moment';
import qs from 'qs';
import { useState } from 'react';

const OperationsExport = () => {
  const toast = useToast();
  const [month, setMonth] = useState(moment().subtract(1, 'months').format('YYYY-MM'));
  const [isExporting, setIsExporting] = useState(false);

  const exportMonth = async () => {
    if (!moment(month, 'YYYY-MM', true).isValid()) {
      toast.error('Choose a month first.');
      return;
    }

    setIsExporting(true);

    try {
      const { data } = await apiClient.get<{
        meetingsCsv: string;
        extraServicesCsv: string;
        meetingsCount: number;
        extraServicesCount: number;
      }>(`${reportApis.downloadOperationsMonthlyExport.endpoint}?${qs.stringify({ month })}`);

      const zip = new JSZip();
      zip.file(`operations-meetings-${month}.csv`, `\uFEFF${data.meetingsCsv}`);
      zip.file(`operations-extra-services-${month}.csv`, `\uFEFF${data.extraServicesCsv}`);

      const blob = await zip.generateAsync({ type: 'blob' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `operations-export-${month}.zip`;
      link.click();
      URL.revokeObjectURL(url);

      toast.success(
        `Exported ${data.meetingsCount} sessions and ${data.extraServicesCount} extra services.`
      );
    } catch (error) {
      const message = (error as { response?: { data?: { error?: { message?: string } } } })
        ?.response?.data?.error?.message;
      toast.error(message ?? 'The export could not be generated.');
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="flex items-end gap-3">
      <div className="w-44">
        <Input
          type="month"
          name="operations-export-month"
          id="operations-export-month"
          label="Operations export month"
          value={month}
          onChange={(event) => setMonth(event.target.value)}
        />
      </div>
      <Button
        variant="secondary"
        buttonText={isExporting ? 'Exporting...' : 'Export for operations'}
        isLoading={isExporting}
        disabled={isExporting || !month}
        onClick={exportMonth}
      />
    </div>
  );
};

export default OperationsExport;
